module.exports = __webpack_public_path__ + "static/img/zzdx.dee57a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzdx.jpg
// module id = 1426
// module chunks = 1